import React, { useState, useEffect } from "react";
import { Button, Card, Container, Dropdown } from "react-bootstrap";
import "./allMedia.scss";
import { socialIcon } from "../../../asset/json/CardDetail";
import "../../common/tooltip.css";
import { LinkContainer } from "react-router-bootstrap";
import { Fade, Zoom, Slide, Bounce } from "react-reveal";
import Reveal from "react-reveal/Reveal";

export function AllSocialMedia() {
  const [data, setdata] = useState(false);
  const opencard = () => {
    setdata(true);
  };
  const closecard = () => {
    setdata(false);
  };
  return (
    <div>
      <div className="card-media mt-5" id="gmb">
        <Zoom top>
          <Card.Title className="media-title">
            All your Social Media in One place
          </Card.Title>
        </Zoom>
        <Zoom cascade>
          <Card.Subtitle className="media-subtitle">
            Manage and plan your social media activities effectively yet
            effortlessly with CloudSocial and remain accessible to users.
          </Card.Subtitle>
        </Zoom>

        <hr className="divider" />

        <Container fluid className="social-container">
          {socialIcon.map(({ img, title, id, alt }) => (
            <Zoom cascade>
              <Card className="social-card" key={id}>
                <Card.Body className="icon-body">
                  <Card.Img
                    className="s-icon"
                    variant="top"
                    src={img}
                    // alt="social media logo"
                    alt={alt}
                  />
                  <Card.Subtitle className="social-title">
                    {title}
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            </Zoom>
          ))}
        </Container>

        <Bounce>
          {/* <LinkContainer to="/pricing">
            <Button className="start">Start Free Trial</Button>
          </LinkContainer> */}
          <div onMouseLeave={closecard}>
            <Dropdown className="" show={data} onClick={opencard}>
              <Dropdown.Toggle className="start">
                Start Free Trial
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdownMenu" onMouseLeave={closecard}>
                <span
                  className="dropdown-menu-arrow  "
                  style={{ borderBottomColor: "#33a5f1 !important" }}
                ></span>
                <Dropdown.Item
                  href="https://app.cloudsocial.io/accounts/gold/9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dropdown-card-item"
                >
                  Brand
                </Dropdown.Item>
                <Dropdown.Item
                  href="https://app.cloudsocial.io/accounts/platinum/17"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dropdown-card-item"
                >
                  Agency
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Bounce>

        <hr className="mt-5" style={{ width: "90%" }} />
      </div>
    </div>
  );
}
